<template>
  <Modal
    width="600"
    :mask-closable="false"
    :value="visible"
    :title="title"
    @on-cancel="handleCancel"
    :footer-hide="true"
  >
    <Form ref="preValidate" :model="formData" :label-width="80">
      <FormItem prop="params">
        <div style="display: flex; justify-content: space-between">
          <Button type="primary" @click="handleCopy">一键复制分享链接</Button>
          <Button type="primary" style="margin-right:80px;" @click="generateCode">生成二维码</Button>
        </div>
      </FormItem>
      <FormItem prop="qrCode" v-show="formData.qrCode">
        <div class="code-box">
          <img :src="formData.qrCode">
          <p>使用微信小程序扫描此二维码</p>
        </div>
        <div class="tips">二维码可截图保存7天(128小时)内反复使用，新生成二维码后，旧二维码将无法使用</div>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
import vueQr from 'vue-qr'

export default {
  name: 'QrCodeModal',
  components: {
    vueQr
  },
  props: {
    visible: Boolean,
    title: String,
    qrData: Object
  },
  data () {
    return {
      formData: {
        params: '',
        qrCode: ''
      }
    }
  },
  methods: {
    handleCancel () {
      this.$emit('update:visible', false)
    },
    handleCopy () {
      this.$emit('copy', this.formData.params)
    },
    generateCode () {
      this.$emit('generate', this.qrData)
    }
  },
  watch: {
    qrData: {
      handler (newVal) {
        this.formData = { ...this.formData, ...newVal }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.code-box img {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  display: block;
}
.tips {
  color: #999;
  font-size: 12px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/global/QrCodeModal.vue